import AdminTimesheetsList from './admin';
import ClientTimesheetsList from './client';
import ContractorTimesheetsList from './contractor';

const tenants = {
    admin: AdminTimesheetsList,
    client: ClientTimesheetsList,
    contractor: ContractorTimesheetsList
};

export default tenants;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/lists/timesheets/tenants/index.jsx